import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import pp_logo from "../../assets/pricePingerLogo.svg";
import { Avatar, Divider, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import "./Header.css";
import { Link, useNavigate } from "react-router-dom";
import Search from "../common/Search/Search";
import { StyledMenu } from "../common/StyledComponents/StyledMenu/StyledMenu";
import { StyledTooltip } from "../common/StyledComponents/StyledTooltip/StyledTooltip";
import LoginModal from "../Login/LoginModal";
import { logout } from "../../api/axiosInstance";
import { CircularProgress } from "@mui/material";
import { DragHandle } from "@mui/icons-material";
import { configs } from "../../api/config";
import CountrySelectorDialog from "../common/CountryDialog/CountryDialog";
import blueDownArrow from "../../assets/blue-dropdown.svg";

const pages = [
  { nav: "Top Deals", navLink: "top-deals-section" },
  { nav: "Blogs", navLink: "blogs-section" },
];

const settings = ["My wishlist"];

interface HeaderProps {
  onCountryChange: (country: { label: string; value: string } | null) => void;
}

const Header: React.FC<HeaderProps> = ({ onCountryChange }) => {
  const navigate = useNavigate();
  // Custom breakpoint for screens below 1200px
  const isBelow1200 = useMediaQuery("(max-width:1200px)");

  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );
  const [openLoginModal, setOpenLoginModal] = React.useState<boolean>(false);

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [isUserLoggedIn, setIsUserLoggedIn] = React.useState<boolean>(false);
  const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>("");

  const theme = useTheme();

  const fontSize = {
    xs: theme.typography.pxToRem(14),
    sm: theme.typography.pxToRem(14),
    md: theme.typography.pxToRem(16),
  };

  let displayName = localStorage.getItem("displayName") || "";
  displayName = displayName?.split(" ")[0];

  useEffect(() => {
    if (displayName !== "") setIsUserLoggedIn(!!displayName);
  }, [displayName]);

  useEffect(() => {}, [isUserLoggedIn]);

  useEffect(() => {}, [openLoginModal]);

  useEffect(() => {}, [searchQuery]);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    if (query.trim()) {
      navigate(`/search?query=${encodeURIComponent(query)}`);
    }
  };

  const handleToggleSearch = () => {
    setIsSearchOpen((prev) => !prev);
  };

  const handleLoginStatus = async () => {
    handleCloseUserMenu();
    setOpenLoginModal(true);
  };

  const handleLogOutStatus = async () => {
    setIsLoading(true);
    // Call your logout API here
    setTimeout(() => {
      // Simulating API call
      logout();
      setIsLoading(false);
      setIsUserLoggedIn(false);
      handleCloseUserMenu();
    }, 2000); // Set timeout to simulate API call duration

    handleCloseUserMenu();
  };

  const handleCloseLoginModal = () => {
    setOpenLoginModal(false);
  };

  const [open, setOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<{
    label: string;
    value: string;
  } | null>(null);

  const handleOpen = () => setOpen(true);

  const handleDialogClose = (country: { label: string; value: any } | null) => {
    setOpen(false);
    if (country) {
      setSelectedCountry(country);
      onCountryChange(country);
    }
  };

  return (
    <>
      {" "}
      <AppBar
        position="static"
        id="header-toolbar"
        sx={{
          marginBottom:1,
          backgroundColor: "white",
          color: "black",
          //  box-shadow: 0px 1px 4px 0px #00000040;
          borderRadius: "14px",
          boxShadow:
            " 0px 1px 4px 0px #00000040, 0px 0px 4px 0px #0000001A inset",
          fontFamily: "Poppins Regular",
        }}
      >
        <Container maxWidth={"xl"} sx={{paddingLeft: 1,paddingRight:1}}>
          <Toolbar disableGutters>
            <IconButton
              disableRipple
              aria-label="price-pinger-logo-label"
              sx={{
                display: { xs: "none", md: "flex" },
                mr: 1,
                marginLeft: "auto",
                "&:hover": { backgroundColor: "transparent" },
                padding: { xs: "0px" },
              }}
              component={Link}
              to="/home"
            >
              <img
                id="price-pinger-logo"
                alt="Price Pinger Logo"
                src={pp_logo}
                className="responsive-logo"
              ></img>
            </IconButton>

            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                id="customized-nav-button"
                size="medium"
                aria-label="nav-menu"
                aria-controls="menu-appbar-nav"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <DragHandle />
              </IconButton>
              <StyledMenu
                id="menu-appbar-nav"
                anchorEl={anchorElNav}
                MenuListProps={{
                  "aria-labelledby": "customized-nav-button",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                  fontSize: { xs: "12px", md: "12px", lg: "15px" },
                }}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                {pages.map((page, i) => (
                  <div style={{ textAlign: "center" }}>
                    <MenuItem
                      key={`menu-item${page.nav}`}
                      onClick={handleCloseNavMenu}
                      sx={{ justifyContent: "center" }}
                    >
                      <Link
                        to={`/home#${page.navLink}`}
                        className="menu-link-styles"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          textAlign="center"
                          className="menu-item-styles"
                        >
                          {page.nav}
                        </Typography>
                      </Link>
                    </MenuItem>
                    <Divider key={`${i}-div`} />
                  </div>
                ))}
                <MenuItem
                  key={`menu-item-plugin-link`}
                  sx={{ justifyContent: "center" }}
                  onClick={() =>
                    window.open(configs.grap_the_plugin_url, "_blank")
                  }
                >
                  <Link
                    // to={`/home#${page.navLink}`}
                    to="#"
                    style={{ textDecoration: "none" }}
                  >
                    <Typography
                      textAlign="center"
                      className="grab-the-plugin-style"
                    >
                      Add Extension
                    </Typography>
                  </Link>
                </MenuItem>
              </StyledMenu>
            </Box>
            <IconButton
              disableRipple
              aria-label="price-pinger-logo-label"
              sx={{
                display: { xs: "flex", md: "none" },
                flexGrow: 1,
                mr: 1,
                marginLeft: "auto",
                "&:hover": { backgroundColor: "transparent" },
              }}
              component={Link}
              to="/home"
            >
              <img
                id="price-pinger-logo"
                alt="Price Pinger Logo"
                src={pp_logo}
                className="responsive-logo"
              ></img>
            </IconButton>
            {/* Button to open the dialog */}
            <Box>
              <Button
                variant="text"
                onClick={handleOpen}
                className="country-selector-button"
                endIcon={
                  <img
                    src={blueDownArrow}
                    alt={"country dropdown"}
                    style={{ width: "8px", height: "6px" }}
                  />
                }
              >
                {/*               {selectedCountry ? `${selectedCountry.value.toString()}` : "IN"} */}
              {
                 selectedCountry
                  ? (isBelow1200 ? selectedCountry.value : selectedCountry.label)
                  : (isBelow1200 ? "IN" : "India")
              }
              </Button>

              {/* Country Selection Dialog */}
              <CountrySelectorDialog open={open} onClose={handleDialogClose} />
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                padding: "0px 8px",
                width: "50%",
              }}
            >
              {!isSearchOpen ? (
                <IconButton
                  onClick={handleToggleSearch}
                  disableRipple
                  sx={{
                    "&:hover": { backgroundColor: "transparent" },
                    display: { xs: "none", sm: "flex", md: "flex" },
                  }}
                >
                  <SearchIcon />
                </IconButton>
              ) : (
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "600px",
                    display: { xs: "none", sm: "flex", md: "flex" },
                    alignItems: "center",
                    justifyContent: "flex-end",
                    /*   border: "1px solid #e2dff7",
                  padding: "4px 8px",
                  borderRadius: "10px",
                  backgroundColor: "rgba(250, 250, 250, 0.93)",*/
                  }}
                >
                  <Search
                    SearchText={"Search"}
                    handleSearch={handleSearch}
                    handleClose={handleToggleSearch}
                  />
                </Box>
              )}
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                display: { xs: "none", sm: "none", md: "flex" },
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              {pages.map((page, index) => (
                <React.Fragment key={page.nav}>
                  <Button
                    key={`button${page.nav}`}
                    //  href={`#${page.navLink}`}
                    className="menu-item-button-styles"
                    sx={{
                      my: 2,
                      mr: index === pages.length - 1 ? 4 : 0, // Add margin right to the last item
                    }}
                    component={Link}
                    to={`/home#${page.navLink}`}
                  >
                    {page.nav}
                  </Button>
                  {index < pages.length - 1 && (
                    <Divider
                      orientation="vertical"
                      sx={{
                        mx: 1,
                        height: "20px",
                        position: "relative",
                        top: "25px",
                      }}
                    />
                  )}
                </React.Fragment>
              ))}
            </Box>
            <Box
              sx={{
                flexGrow: 0,
                display: { xs: "none", sm: "none", md: "block" },
              }}
            >
              <div>
                <Button
                  id="plugin_link"
                  variant="contained"
                  className="save_item"
                  sx={{
                    fontSize: fontSize,
                    fontWeight: 700,
                    whiteSpace: "nowrap",
                    "&.Mui-disabled": {
                      color: "#fff",
                    },
                  }}
                  onClick={() =>
                    window.open(configs.grap_the_plugin_url, "_blank")
                  }
                >
                  Add Extension
                </Button>
              </div>

              {/*  <Search SearchText={"Search.."} handleSearch={handleSearch} /> */}
            </Box>
            {isUserLoggedIn ? (
              <Box
                sx={{
                  flexGrow: 0,
                  mr: 1,
                  ml: 1,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography
                  textAlign="center"
                  className="display-name-styles"
                  sx={{ display: { xs: "none", sm: "none", md: "block" } }}
                >
                  {displayName || "Guest"}
                </Typography>

                <StyledTooltip title="Open settings">
                  <IconButton
                    key="user-menu"
                    id="customized-avatar-menu"
                    onClick={handleOpenUserMenu}
                    sx={{ p: 0 }}
                  >
                    {isLoading ? (
                      <CircularProgress size={24} />
                    ) : (
                      <Avatar src="/static/images/avatar/2.jpg" />
                    )}
                  </IconButton>
                </StyledTooltip>
                <StyledMenu
                  sx={{ mt: 1 }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  MenuListProps={{
                    "aria-labelledby": "customized-avatar-menu",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  {settings.map((setting, i) => (
                    <div style={{ textAlign: "center" }}>
                      {i !== 0 && <Divider key={`${i}-div`} />}
                      <StyledTooltip
                        title={"Coming soon"}
                        placement="top-start"
                        slotProps={{
                          popper: {
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [0, -24],
                                },
                              },
                            ],
                          },
                        }}
                      >
                        <div>
                          <MenuItem
                            disabled
                            key={setting}
                            id={`${setting}-${i}`}
                            onClick={handleCloseUserMenu}
                            sx={{ cursor: "pointer" }}
                          >
                            <Typography>{setting}</Typography>
                          </MenuItem>
                        </div>
                      </StyledTooltip>
                    </div>
                  ))}
                  {isUserLoggedIn && (
                    <MenuItem
                      key={"logOut"}
                      onClick={handleLogOutStatus}
                      sx={{
                        border: "0.25px solid rgba(0, 0, 0, 0.18)",
                        borderRadius: "6px",
                        justifyContent: "center",
                      }}
                    >
                      <Typography>Logout</Typography>
                    </MenuItem>
                  )}
                </StyledMenu>
              </Box>
            ) : (
              <Box
                sx={{
                  flexGrow: 0,
                  mr: {xs:0,sm:0,md:1,lg:1},
                  ml: {xs:0,sm:0,md:1,lg:1},
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="outlined"
                  key={"login"}
                  className="login-outline-button"
                  onClick={handleLoginStatus}
                  sx={{
                    width: "70px",
                    display: { xs: "none", sm: "block", md: "block" },
                    fontWeight: 400,
                    fontSize:"14px",
                    verticalAlign: "middle",
                    background:
                      "linear-gradient(90deg, #FF1400 0%, #0F0E96 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    textFillColor: "transparent",
                  }}
                >
                  Login
                </Button>
                <Button
                  variant="text"
                  key={"login-text"}
                  className="login-text-button"
                  onClick={handleLoginStatus}
                  sx={{
                    //  width: "100px",
                    fontSize: "12px",
                    display: {
                      xs: "block",
                      sm: "none",
                      md: "none",
                    },
                    fontWeight: 400,
                    verticalAlign: "middle",
                    background:
                      "linear-gradient(90deg, #FF1400 0%, #0F0E96 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    textFillColor: "transparent",
                    minWidth:"40px",
                    padding:0,
                  }}
                >
                  Login
                </Button>
              </Box>
            )}
          </Toolbar>
        </Container>
        <LoginModal
          openModal={openLoginModal}
          handleClose={handleCloseLoginModal}
        />
      </AppBar>
      <Box sx={{ display: { xs: "block", sm: "none", md: "none" } }}>
        <Search
          SearchText={"Search"}
          handleSearch={handleSearch}
          handleClose={handleToggleSearch}
        />
      </Box>
    </>
  );
};

export default Header;
